import feature1 from "../../images/icons/f1.svg";
import feature2 from "../../images/icons/f2.svg";
import feature3 from "../../images/icons/f3.svg";
import feature4 from "../../images/icons/f4.svg";
import feature5 from "../../images/icons/f5.svg";
import feature6 from "../../images/icons/f6.svg";

export const featuresData = [
  {
    id: 1,
    img: feature1,
    alt: "feature1",
    title: "FEATURE NO1",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
  {
    id: 2,
    img: feature2,
    alt: "feature2",
    title: "FEATURE NO2",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
  {
    id: 3,
    img: feature3,
    alt: "feature3",
    title: "FEATURE NO3",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
  {
    id: 4,
    img: feature4,
    alt: "feature4",
    title: "FEATURE NO4",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
  {
    id: 5,
    img: feature5,
    alt: "feature5",
    title: "FEATURE NO5",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
  {
    id: 6,
    img: feature6,
    alt: "feature6",
    title: "FEATURE NO6",
    desc: "I’m really good feature. That’s why we want to talk about it",
  },
];
